<div class="container-fluid">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color:white;">
      <div class="col">
        <h3 style="margin-bottom: 0 !important;">
          <span style="margin-left: 15px;"><fa-icon [icon]="['fas', 'bell']"> </fa-icon> Action Alerts </span>
        </h3>
      </div>
      <div class="col pull-right">
        <app-eca-ghost-btn class="card-action-icon float-right"
                           btnIcon="question-circle" btnType="warning"
                           (btnClicked)="openAlertsLoadingHelp()"></app-eca-ghost-btn>
      </div>
    </ng-template>
    <ng-template pTemplate="content" class="eca-card-body">
      <div class="container-fluid" style="margin-bottom: 50px; padding-right: 0; padding-left: 0;">
        <div *ngIf="alertsLoading" class="text-center">
          <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen"
                           secondaryColor="green"></fa-duotone-icon>
        </div>
        <div *ngIf="!alertsLoading">
          <div class="container-fluid" style="padding-left: 0; padding-right: 0;">
            <div class="row">
              <div class="col">
                <div *ngIf="loadingAlerts" class="text-center">
                  <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x"
                                   primaryColor="darkgreen" secondaryColor="green"></fa-duotone-icon>
                </div>
                <div *ngIf="!loadingAlerts">
                  <p-table [totalRecords]="alertInfos?.length" #tt [value]="alertInfos" [globalFilterFields]="columns" dataKey="id"
                           styleClass="p-datatable-striped p-datatable-responsive-eca"
                           [scrollable]="!isOnMobile &&    alertInfos?.length > 10" scrollHeight="500px" [rows]="10" [responsive]="true" [columns]="columns">
                    <ng-container>
                      <ng-template pTemplate="caption">
                        <div class="row d-flex justify-content-between align-items-center">
                          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                            <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                              <div class="col-auto">
                                <h5 class="eca-primary-text h5-relative-font-size" *ngIf="!alertsFilter.showOnlyRisks">
                                  <span *ngIf="alertInfos"> {{ alertInfos.length }}</span>
                                  Action Alerts
                                </h5>
                              </div>
                            </div>
                          </div>
                          <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                            <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                              <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-8">
                                      <span class="p-input-icon-left">
                                          <i class="pi pi-search"></i>
                                          <input pInputText type="text" class="form-control" id="ctrlSearchInput" style="min-width: 150px"
                                                 placeholder="Search All" (input)="tt.filterGlobal($event.target.value, 'contains')">
                                        </span>
                              </div>
                              <div class="col-auto">
                                <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width: 10%" pSortableColumn="alertType">
                          Type
                          <p-sortIcon field="alertType"></p-sortIcon>
                          <p-columnFilter field="alertType" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" *ngIf="showFilters">

                            <ng-template pTemplate="filter" let-alertType let-filter="filterCallback">
                              <p-multiSelect [ngModel]="alertType" [options]="alertTypes" placeholder="Any" (onChange)="filter($event.value)"
                                             [optionLabel]="alertType | entityAlertTypeString" display="chip" [filter]="false">
                                <ng-template let-option pTemplate="item">
                                  <div class="p-multiselect-representative-option">
                                    <span class="p-ml-1"> {{ option.label }}</span>
                                  </div>
                                </ng-template>
                              </p-multiSelect>
                            </ng-template>
                          </p-columnFilter>
                        </th>
                        <th style="width: 10%" pSortableColumn="title">
                          Title
                          <p-sortIcon field="title"></p-sortIcon>
                        </th>
                        <th style="width: 20%" pSortableColumn="detailsHtml">
                          Details
                          <p-sortIcon field="detailsHtml"></p-sortIcon>
                        </th>
                        <th style="width: 10%" pSortableColumn="directLink">
                          Link
                          <p-sortIcon field="directLink"></p-sortIcon>
                        </th>
                        <th style="width: 13%" pSortableColumn="followUpOn">
                          Follow Up On
                          <p-sortIcon field="followUpOn"></p-sortIcon>
                          <p-columnFilter type="date" field="followUpOn" display="menu"></p-columnFilter>
                        </th>

                        <th style="width: 10%" pSortableColumn="alertLevel">
                          Alert Level
                          <p-sortIcon field="alertLevel"></p-sortIcon>
                          <p-columnFilter field="alertLevel" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" *ngIf="showFilters">
                            <ng-template pTemplate="filter" let-alertLevel let-filter="filterCallback">
                              <p-multiSelect [ngModel]="alertLevel" [options]="alertNoticeLevels" placeholder="Any" (onChange)="filter($event.value)"
                                             [optionLabel]="alertLevel  | alertNoticeLevelString" display="chip" [filter]="false">
                                <ng-template let-option pTemplate="item">
                                  <div class="p-multiselect-representative-option">
                                    <span class="p-ml-1"> {{ option.label }}</span>
                                  </div>
                                </ng-template>
                              </p-multiSelect>
                            </ng-template>
                          </p-columnFilter>
                        </th>
                        <th style="font-weight: bold; width: 10%;"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-alertInfo let-columns="columns" style="margin: 15px;">
                      <tr [style.color]="alertInfo.getRiskColour()">
                        <td *ngFor="let col of columns">
                          <span class="p-column-title">{{col.header}}: </span>
                          <div>
                            <span *ngIf="col.type=== 'text'">
                              {{alertInfo[col.field]}}
                            </span>
                            <span *ngIf="col.type=== 'alertType'">
                              {{alertInfo[col.field] | entityAlertTypeString}}
                            </span>
                            <span *ngIf="col.type=== 'html'" [innerHTML]="alertInfo[col.field]">
                            </span>
                            <span *ngIf="col.type=== 'link'">
                              <a [routerLink]="alertInfo[col.field]">{{alertInfo.linkText}}</a>
                            </span>
                            <span *ngIf="col.type === 'date'">
                              {{alertInfo[col.field] | date:'dd/MM/yyyy'}}
                            </span>
                            <span *ngIf="col.type === 'alertNoticeLevel'">
                              {{alertInfo[col.field] | alertNoticeLevelString}}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">
                            <app-eca-row-menu (viewBtnClicked)="dismissAlert(alertInfo)"
                                              viewBtnText="Dismiss"
                                              [viewBtnVisible]="alertInfo.canBeDismissed"
                                              [rowMenuVisible]="false"
                                              [contextItem]="alertInfo">
                            </app-eca-row-menu>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
